import React from "react";
import { Box, keyframes } from "@mui/system";

const AnimatedDots = ({
  text = "Processing",
  color = "#000",
  speed = 1, // animation duration in seconds
  dotColor = "currentColor", // color of the dots
  backgroundColor = "transparent", // background between dots
  gap = "2px", // gap between text and dots
}) => {
  const loaderAnimation = keyframes`
    to {
      clip-path: inset(0 -34% 0 0);
    }
  `;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end", // Align items at the bottom
        gap: gap,
        color: color,
        // fontSize: '1rem',
        lineHeight: 1, // Ensure text aligns properly with dots
      }}
    >
      {text && <span>{text}</span>}
      <Box
        sx={{
          width: "1rem",
          aspectRatio: "4",
          background: `radial-gradient(circle closest-side, ${dotColor} 90%, ${backgroundColor}) 0/calc(100%/3) 100% space`,
          clipPath: "inset(0 100% 0 0)",
          animation: `${loaderAnimation} ${speed}s steps(4) infinite`,
          willChange: "clip-path",
          marginBottom: "0.1em", // Small adjustment to perfect the alignment
        }}
      />
    </Box>
  );
};

export default AnimatedDots;
